var exports = {
  "kL": "xfb577c5e--7cbb48--container",
  "pq": "xfb577c5e--7cbb48--info",
  "nf": "xfb577c5e--7cbb48--link",
};

module.exports = exports;
